module.exports = __webpack_public_path__ + "static/media/creative.ec128c56.jpg";